import { useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Returns an onClick handler that:
 *  1. Fires a backend tracking event (/api/track/call)
 *  2. Fires a Google Analytics event (window.gtag) if available
 *  3. Does NOT block the default tel: navigation
 */
export default function useCallTracking() {
  return useCallback((source) => {
    return () => {
      // Backend tracking (fire & forget)
      try {
        axios.post(
          `${API}/track/call`,
          {
            source,
            page: typeof window !== "undefined" ? window.location.pathname : "",
            referrer: typeof document !== "undefined" ? document.referrer : "",
          },
          { timeout: 2000 }
        ).catch(() => {});
      } catch (_) { /* noop */ }

      // GA4 / Google Ads event (only fires if gtag is loaded after consent)
      try {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
          window.gtag("event", "call_click", {
            event_category: "engagement",
            event_label: source,
          });
          if (window.__GA_CONVERSION_TAG__) {
            window.gtag("event", "conversion", {
              send_to: window.__GA_CONVERSION_TAG__,
              value: 1.0,
              currency: "GBP",
              event_label: source,
            });
          }
        }
      } catch (_) { /* noop */ }
    };
  }, []);
}
